import {connect} from 'react-redux'

import type {State} from '../../../../reducers/types'
import {getOverviewProject, getProject, isArchivedProject} from '../../../../selectors'
import {emptyArray} from '../../../../utils/empty'

import BuildTypes from './BuildTypes'
import type {OwnProps, StateProps} from './BuildTypes.types'

const mapStateToProps = (state: State, {projectId}: OwnProps): StateProps => {
  const overviewProject = getOverviewProject(state, projectId)
  const project = getProject(state, projectId)
  const hasFavorites = (overviewProject?.buildTypes?.buildType.length ?? 0) > 0
  return {
    overviewBuildTypeIds: overviewProject?.buildTypes?.buildType ?? emptyArray,
    buildTypeIds: project?.buildTypes?.buildType ?? emptyArray,
    archivedProject: isArchivedProject(state, projectId),
    hasFavorites,
  }
}

export default connect(mapStateToProps)(BuildTypes)
